export default class VoicesSingle {
  constructor() {
    this.container = null;
    this.nav = null;
    this.headings = [];
    this.bindOnScroll = this.onScroll.bind(this);
    this.cacheElements();
  }

  start() {
    if (!this.container || !this.nav) return;
    this.buildNav();
    window.addEventListener("scroll", this.bindOnScroll, { passive: true });
    this.onScroll();
  }

  reset() {
    this.destruct();
    this.cacheElements();
    this.start();
  }

  destruct() {
    window.removeEventListener("scroll", this.bindOnScroll);
    this.headings = [];
  }

  cacheElements() {
    this.container = document.querySelector(".js-voices-single-content");
    this.nav = document.querySelector(".js-voices-chapter-nav");
  }

  buildNav() {
    const headings = Array.from(this.container.querySelectorAll("h2"));
    this.headings = headings;
    this.nav.innerHTML = "";

    headings.forEach((heading, index) => {
      const id = `voices-chapter-${index + 1}`;
      heading.id = id;

      const li = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${id}`;
      link.dataset.target = id;
      link.innerHTML = `<span>Chapter ${(index + 1).toString().padStart(2, "0")}</span><strong>${heading.textContent.trim()}</strong>`;
      link.addEventListener("click", (event) => {
        event.preventDefault();
        const target = document.getElementById(id);
        if (!target) return;
        const top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top, behavior: "smooth" });
      });
      li.appendChild(link);
      this.nav.appendChild(li);
    });
  }

  onScroll() {
    if (!this.headings.length) return;
    let currentId = this.headings[0].id;

    for (const heading of this.headings) {
      if (heading.getBoundingClientRect().top <= 120) {
        currentId = heading.id;
      }
    }

    const links = this.nav.querySelectorAll("a");
    links.forEach((link) => {
      if (link.dataset.target === currentId) {
        link.classList.add("is-current");
      } else {
        link.classList.remove("is-current");
      }
    });
  }
}
